import React from "react";
import {AirplaneFill, InfoCircleFill, PencilFill, PlusCircleFill, SignTurnRightFill} from "react-bootstrap-icons";

export class SysButton extends React.Component<any, any> {

    render() {
        return (
            <div {...this.prepareProps()}>
                {this.getIcon(this.props.type || '')}
                {this.props.text && <span>{this.props.text}</span>}
                {this.props.children && this.props.children}
            </div>
        );
    }

    protected prepareProps(): {} | any {
        let props = {...this.props};

        props?.type && delete props.type;
        props?.text && delete props.text;

        if (this.props?.className) {
            props.className = this.props.className + ' sysButton';
        } else {
            props.className = 'sysButton';
        }

        return props;
    }

    private getIcon(type: string): any {
        if (type === "PencilFill") {
            return <PencilFill/>;
        }
        if (type === "SignTurnRightFill" || type === "close") {
            return <SignTurnRightFill/>;
        }
        if (type === "AirplaneFill") {
            return <AirplaneFill/>;
        }
        if (type === "PlusCircleFill") {
            return <PlusCircleFill/>;
        }
        return <InfoCircleFill/>;
    }
}
